/**
 * SCROLL_TOP モジュール
 * - スクロール位置が100pxを超えたら「ページトップへ戻る」ボタンを表示
 * - クリック時にスムーズにトップへ戻る
 */
export const SCROLL_TOP = {
  init() {
    const topButton = document.querySelector('.js-pagetop')
    if (!topButton) return

    // スクロールイベント：表示/非表示切り替え
    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        topButton.style.display = 'block'
        topButton.style.opacity = '1'
        topButton.style.transition = 'opacity 0.3s ease'
      } else {
        topButton.style.opacity = '0'
        // 少し遅れて display: none にする（フェードアウトっぽく）
        setTimeout(() => {
          if (window.scrollY <= 100) topButton.style.display = 'none'
        }, 300)
      }
    })

    // クリックイベント：スムーズスクロールでトップへ
    topButton.addEventListener('click', e => {
      e.preventDefault()
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })
  },
}
